import { Routes } from "@angular/router";
import { AndroidAppComponent } from "./android-app/android-app.component";
import { IosAppComponent } from "./ios-app/ios-app.component";
import { SalesMobileAppComponent } from "./sales-mobile-app.component";

export const salesMobileAppRoutes: Routes = [
  { path: "", component: SalesMobileAppComponent },
  { path: "ios-instruction", component: IosAppComponent },
  {
    path: "android-instruction",
    component: AndroidAppComponent,
  },
];
